import { BaseConfig } from '../ServiceConfig';

export interface UserPrivacyPolicyConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.UserPrivacyPolicyConfigData';
  url: string;
  cachingExpiredInDay: number;
}

export const UserPrivacyPolicyConfigurationFields: (keyof UserPrivacyPolicyConfiguration)[] = [
  'url',
  'cachingExpiredInDay'
];

export const BlankUserPrivacyPolicyConfiguration: UserPrivacyPolicyConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.UserPrivacyPolicyConfigData',
} as UserPrivacyPolicyConfiguration;
